import { useEffect } from 'react';
import { useActivateBonusViaLink, useApiContext } from 'react-easyrocket';
import { Navigate, useParams } from 'react-router';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { useRoute } from 'src/router/hooks';

export function ActivateBonus() {
  const { bonusId } = useParams();
  const { isAuthenticated } = useApiContext();
  const { mutateAsync } = useActivateBonusViaLink();
  const { startRegistration } = useAuthFlow();
  const { ROUTE } = useRoute();

  useEffect(() => {
    if (bonusId) {
      const proceed = () => mutateAsync({ bonus_id: bonusId });
      if (isAuthenticated) {
        proceed();
      } else {
        startRegistration({ onSuccess: proceed });
      }
    }
  }, [isAuthenticated]);

  return <Navigate to={ROUTE.MAIN.get()} />;
}
